module.exports = __webpack_public_path__ + "static/img/kbc_sestre_milosrdnice_zagreb.3f79cad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/kbc_sestre_milosrdnice_zagreb.png
// module id = /ZBC
// module chunks = 0